<template>
  <base-table :service="assetService" fetch-func="all" :fetch-params="params" :columns="$options.columns" :per-page="$options.perPage" default-sort-field="third_party_code" :checkable="true" :checked="checked" @check="onCheck" :selectable="true" :selected="selected" @select="onSelect" :sticky="true" :infinite-scroll="true" :scrollable-element="scrollableElement" @paginate="onPaginate" ref="baseTable"></base-table>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { AssetService } from "@/services/asset.service.js";

export default {
  additionalParams: {
    includes: "code"
  },
  columns: [
    {
      field: "id",
      label: "ID",
      meta: {
        hidden: true
      }
    },
    {
      field: "third_party_code",
      label: "SAP ID",
      sortable: true,
      meta: {
        valuePath: "thirdPartyCode",
        class: "no-wrap"
      }
    },
    {
      field: "code_id",
      label: "CODE",
      meta: {
        valuePath: "code.code",
        hidden: true
      }
    },
    {
      field: "code_id",
      label: "TYPE",
      sortable: true,
      meta: {
        valuePath: "code.name",
        class: "no-wrap"
      }
    }
  ],
  perPage: 1000,
  props: {
    scrollableElement: {},
    selected: {
      type: Object,
      default: () => {}
    },
    checked: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BaseTable
  },
  data: () => ({
    assetService: AssetService,
    params: {}
  }),
  created() {
    this.setParams();
  },
  methods: {
    fetch() {
      this.$refs.baseTable.fetchData();
    },
    setParams() {
      this.params = {
        ...this.$options.additionalParams
      };
    },
    onSelect(selected) {
      this.$emit("select", selected);
    },
    onCheck(checked) {
      this.$emit("check", checked);
    },
    onPaginate(pagination) {
      this.$emit("update:total", pagination.total);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Assets/list/partials/tableSingle.vue